import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import Footer from '../Layaouts/Footer';

export default function PrivacyPolicy() {

    const [isLogin, setIsLogin] = useState(!!localStorage.getItem("authToken"));



    const sections = [
        {
            title: "1. Information We Collect",
            content: "We collect personal information that you provide directly to us, including but not limited to: name, email address, phone number, date of birth, educational background, profession, family information, and photographs. We also automatically collect technical information such as IP address, browser type, and usage data through cookies and similar technologies."
        },
        {
            title: "2. How We Use Your Information",
            content: "Your information is used to: create and maintain your matrimony profile, facilitate matches with potential partners, communicate with you about our services, improve our platform, ensure security and prevent fraud, and comply with legal obligations. We will never use your personal information for purposes unrelated to matrimonial services without your explicit consent."
        },
        {
            title: "3. Information Sharing and Disclosure",
            content: "We share your biodata and profile information only with registered members of Gujarati NRI Matrimony for matrimonial purposes. We do not sell, trade, or rent your personal information to third parties. Your information may be disclosed to: potential matches within our community, service providers who assist our operations, law enforcement when required by law, or in connection with business transfers."
        },
        {
            title: "4. Data Storage and Security",
            content: "We implement industry-standard security measures to protect your personal information. Your data is stored on secure servers with restricted access. While we take reasonable precautions, no method of electronic transmission or storage is 100% secure. We retain your personal information for as long as your account is active or as needed to provide services."
        },
        {
            title: "5. Your Rights and Choices",
            content: "You have the right to: access, update, or delete your personal information; opt-out of marketing communications; restrict certain data processing; and export your data. You can manage these preferences through your account settings or by contacting us directly. You may deactivate your account at any time, though some information may be retained for legal purposes."
        },
        {
            title: "6. Cookies and Tracking Technologies",
            content: "We use cookies and similar technologies to enhance your experience, analyze site usage, and deliver personalized content. Cookies help us remember your preferences, understand how you interact with our service, and improve our platform. You can control cookie settings through your browser, though disabling cookies may affect certain features."
        },
        {
            title: "7. Third-Party Links and Services",
            content: "Our website may contain links to third-party websites or services. This Privacy Policy applies only to Gujarati NRI Matrimony. We are not responsible for the privacy practices of third-party sites. We encourage you to review the privacy policies of any third-party sites you visit through our platform."
        },
        {
            title: "8. Children's Privacy",
            content: "Our services are intended for users who are 18 years of age or older. We do not knowingly collect personal information from children under 18. If we become aware that we have collected personal information from a child under 18, we will take steps to delete such information promptly."
        },
        {
            title: "9. International Data Transfers",
            content: "As a platform serving NRIs, your information may be transferred to and processed in countries other than your country of residence. We ensure appropriate safeguards are in place to protect your data during international transfers in compliance with applicable data protection laws."
        },
        {
            title: "10. Data Breach Notification",
            content: "In the event of a data breach that compromises your personal information, we will notify you and relevant authorities as required by law. We will take immediate steps to investigate the breach, mitigate damages, and prevent future occurrences."
        },
        {
            title: "11. Changes to This Privacy Policy",
            content: "We may update this Privacy Policy from time to time to reflect changes in our practices or legal requirements. We will notify you of any material changes by posting the updated policy on our website and indicating the effective date. Your continued use of our services after changes constitutes acceptance of the updated policy."
        },
        {
            title: "12. Contact Us",
            content: "If you have any questions, concerns, or requests regarding this Privacy Policy or your personal information, please contact our Privacy Team at privacy@gujaratinrimatrimony.com or through the contact form on our website. We typically respond to privacy-related inquiries within 48 business hours."
        }
    ];

    return (
        <div className="min-h-screen bg-gray-50">
            {/* Navbar */}

            {
                !isLogin && <nav className="fixed top-0 w-full bg-[#151515] shadow-md z-50">
                    <div className="max-w-7xl mx-auto flex items-center justify-between p-4">
                        <img src="/images/logo.png" alt="Logo" className="h-10" />
                        <div className="flex gap-3 sm:gap-4">
                            <NavLink
                                to="/signup"
                                className="px-4 py-2 bg-[#E72848] border border-[#E72848] rounded-lg text-white text-sm sm:text-base shadow hover:bg-[#E72848]/80"
                            >
                                Register Free
                            </NavLink>
                            <NavLink
                                to="/signin"
                                className="px-4 py-2 border border-white text-white rounded-lg text-sm sm:text-base hover:bg-white hover:text-[#151515] transition"
                            >
                                Log In
                            </NavLink>
                        </div>
                    </div>
                </nav>
            }


            {/* Content */}
            <div className="max-w-4xl mx-auto px-4 md:px-8 pt-28 pb-20">

                {/* Page Header */}
                <div className="text-center mb-12">
                    <h1 className="text-4xl font-bold text-gray-800 mb-4">Privacy Policy</h1>
                    <p className="text-gray-600 text-lg max-w-2xl mx-auto">
                        Your privacy is important to us. This policy explains how we collect, use, and protect your personal information.
                    </p>
                    <p className="text-gray-500 text-sm mt-2">
                        Last updated: {new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}
                    </p>
                </div>

                {/* Direct Content Sections */}
                <div className="space-y-8">
                    {sections.map((section, i) => (
                        <div key={i} className="bg-white rounded-xl shadow-sm border p-6">
                            <h3 className="text-xl font-semibold text-gray-800 mb-4">{section.title}</h3>
                            <p className="text-gray-700 leading-relaxed">{section.content}</p>
                        </div>
                    ))}
                </div>

                {/* Consent Block */}
                <div className="bg-blue-50 border-2 border-blue-200 rounded-xl p-8 mt-12 shadow-sm">
                    <h3 className="text-2xl font-bold text-gray-800 mb-4">Your Privacy Choices</h3>
                    <p className="text-gray-700 mb-4">
                        By using our services, you consent to the collection and use of your information as described in this Privacy Policy.
                    </p>
                    <p className="text-gray-700 mb-6">
                        You can manage your privacy settings and preferences through your account dashboard at any time.
                    </p>

                    <div className="flex gap-4 flex-wrap">
                        <button className="bg-[#E72848] hover:bg-[#E72848]/80 text-white font-semibold py-3 px-8 rounded-lg transition duration-200">
                            Manage Privacy Settings
                        </button>
                        <button className="bg-gray-600 hover:bg-gray-700 text-white font-semibold py-3 px-8 rounded-lg transition duration-200">
                            Download My Data
                        </button>
                    </div>
                </div>
            </div>

            {
                !isLogin && <Footer />
            }
            {/* Footer */}

        </div>
    );
}